// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.result_qualifier_enum */
var ResultQualifierEnum;
(function (ResultQualifierEnum) {
    ResultQualifierEnum["EQ"] = "EQ";
    ResultQualifierEnum["LT"] = "LT";
    ResultQualifierEnum["LTE"] = "LTE";
    ResultQualifierEnum["GT"] = "GT";
    ResultQualifierEnum["GTE"] = "GTE";
    ResultQualifierEnum["DETECTED"] = "DETECTED";
    ResultQualifierEnum["NOT_DETECTED"] = "NOT_DETECTED";
    ResultQualifierEnum["TEXT"] = "TEXT";
})(ResultQualifierEnum || (ResultQualifierEnum = {}));
;
export default ResultQualifierEnum;
/** Zod schema for result_qualifier_enum */
export const resultQualifierEnum = z.nativeEnum(ResultQualifierEnum);
//# sourceMappingURL=ResultQualifierEnum.js.map